
import * as types from '../constants/actionTypes';
import { getSelectedPresetDetails } from '../selectors/entities/general';
import { onDetailChanged, onButtonChanged, onContrastChanged } from './render';

export function setViewTab(payload) {
  return {
    type: types.SET_VIEWED_TAB,
    payload
  };
}

export function setDetailViewTab(payload) {
  return {
    type: types.SET_DETAIL_VIEWED_TAB,
    payload
  };
}


export function toggleFilterMenu(payload) {
  return {
    type: types.TOGGLE_FILTER_MENU,
    payload
  };
}


export function applyFilter(filterType, filterValue, checked) {
  return {
    type: types.APPLY_FABRIC_FILTER,
    filterType,
    filterValue,
    checked,
  };
}

export function applyPreset(preset) {

  return async (dispatch, getState) => {
    dispatch({
      type: types.APPLY_DETAIL_PRESET,
      preset,
    });

    const selectedPreset = getSelectedPresetDetails(getState())
    for (let section in selectedPreset) {
      const value = selectedPreset[section];
      if (!value || !value.attrValue) {
        continue;
      }

      switch (section) {
        case 'buttons': {
          dispatch(onButtonChanged(value.attrValue, section), getState())
          break;
        }
        case 'collarFabric': {
          dispatch(onContrastChanged(value.attrValue, 'collar'), getState())
          break;
        }
        default: {
          dispatch(onDetailChanged(value.attrValue, section, true, true), getState())
          break;
        }
      }

    }
    dispatch({
      type: types.RECEIVED_DETAIL_PRESET,
      selectedPreset,
    })
  };
}

export function clearFilter(filterType) {
  return {
    type: types.CLEAN_FABRIC_FILTER,
    filterType,
  };
}


export function infoButtonClicked(payload) {
  return {
    type: types.INFO_BUTTON_CLICKED,
    payload
  };
}

export function setFabricPreview(fabric) {
  return {
    type: types.FABRIC_PREVIEW_SETTED,
    fabric,
  };
}

export function setPageForBuilder(payload) {
  return {
    type: 'SET_BUILDER_PAGE',
    payload
  }
}

export function toggleSizeSnack(state) {
  return {
    type: 'TOGGLE_SIZE_SNACK',
    state
  }
}

export function toggleModal(id) {
  return {
    type: 'TOGGLE_MODAL',
    id
  }
}


export function zoomButtonClicked(payload) {
  return {
    type: types.ZOOM_BUTTON_CLICKED,
    payload
  };
}

export function imagesLoading(payload) {
  return {
    type: types.IMAGES_LOADING,
    payload
  };
}

export function catalogProductClicked(payload) {
  return {
    type: types.CATALOG_PRODUCT_OPENED,
    payload
  };
}

export function screenResize(payload) {
  return {
    type: 'SCREEN_RESIZE',
    payload
  };
}

export function toggleSetParamsError(payload){
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PARAMS_ERROR',
      payload,
    });
  };
}